import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unlock",
  "use": "icon-unlock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-unlock\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M9.22,10.89h7.22a.56.56,0,0,1,.56.56V17a.56.56,0,0,1-.56.56H7.56A.56.56,0,0,1,7,17V11.45a.56.56,0,0,1,.56-.56h.55v-.56a3.89,3.89,0,0,1,7.37-1.74l-1,.5a2.78,2.78,0,0,0-5.27,1.24Zm1.67,2.78v1.11h2.22V13.67Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol